export enum TransferTypeEnum {
  'GENERAL_SAME_CHAIN' = 'generalSameChain',
  'GENERAL_CROSS_CHAIN' = 'generalCrossChain',
  'E_BRIDGE' = 'eBridge',
  'E_TRANSFER' = 'eTransfer',
}
